$(document).ready(function () {

	$('.menuleft__strzalka').on('click', function() {
		var _this = $(this);
		var hand = _this.next('.collapse');
		if (hand.hasClass('show')) {
			hand.removeClass('show')
		}else {
			hand.addClass('show')
		}

		if (_this.hasClass('show')) {
			_this.removeClass('show')
		}else {
			_this.addClass('show')
		}
	})

	if ( $('.menuleft__a.active').length ) {
		var _this = $('.menuleft__a.active');
		_this.parents('.hand_collapse').addClass('show');
		_this.parents('.hand_collapse').prev('.menuleft__strzalka').addClass('show');
	}

})